import { RouteRecordRaw } from "vue-router";
import HomePage from '@/views/home/index.vue'
import Coupons from "@/views/coupons/index.vue"
import MyNumbers from "@/views/my-numbers/index.vue"
import MyBets from "@/views/my-bets/index.vue"
import Payouts from "@/views/payouts/index.vue"
import LastestResults from "@/views/lastest-results/index.vue"
import Demo from "@/views/demo/socketio.vue"
import HowToPlay from "@/views/how-to-play/index.vue";
import Markets from "@/views/markets/index.vue";
import TermsAndConditions from "@/views/terms-and-conditions/index.vue";

const publicRoutes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Home Page',
        meta: {
            isHidenNatigation: true,
            isHomePage: true
        },
        component: HomePage,
    },
    {
        path: '/coupons/:gameSlug',
        name: 'Coupons',
        component: Coupons,
    },
    {
        path: '/my-numbers',
        name: 'My Numbers',
        component: MyNumbers,
    },
    {
        path: '/my-bets',
        name: 'My Bets',
        component: MyBets,
    },
    {
        path: '/payouts',
        name: 'Payouts',
        component: Payouts,
    },
    {
        path: '/lastest-results',
        name: 'Lastest Results',
        component: LastestResults,
    },
    {
        path: '/demo',
        name: 'Web socket',
        component: Demo,
    },
    {
        path: '/how-to-play',
        name: 'How to Play',
        meta: { isOtherPage: true },
        component: HowToPlay,
    },
    {
        path: '/markets',
        name: 'Market Descriptions',
        meta: { isOtherPage: true },
        component: Markets,
    },
    {
        path: '/terms-and-conditions',
        name: 'Terms & Conditions',
        meta: { isOtherPage: true },
        component: TermsAndConditions,
    },
];

export default publicRoutes;
